import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ModalModule } from 'src/shared/modal';
import { TemplateLogOverlayComponent } from './template-log-overlay.component';
import { TemplateLogOverlayService } from './template-log-overlay.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { AuditLogModule } from 'src/components/audit-log/audit-log.module';

@NgModule({
  declarations: [TemplateLogOverlayComponent],
  providers: [TemplateLogOverlayService],
  imports: [
    CommonModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    ModalModule,
    MatFormFieldModule,
    MatProgressBarModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    AuditLogModule,
  ],
})
export class TemplateLogOverlayModule {}